import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "../store/index";
import ProjectNotificationSlice from "../slices/ProjectNotificationSlice";
import ProjectNotificationService from "../../services/ProjectNotificationService";
import { ProjectNotificationModel } from "../../models/ProjectNotificationModel";

export const ProjectNotificationActions = ProjectNotificationSlice.actions;

export const fetchProjectNotifications = (
  userId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response: ProjectNotificationModel[] =
      await ProjectNotificationService.getAllProjectNotifications(userId);
    dispatch(ProjectNotificationActions.setProjectNotifications(response));
  };
};

export const readAllProjectNotifications = (
  userId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    await ProjectNotificationService.readAllProjectNotifications(userId);
    const response = getState().projectNotifications.notifications.map(
      (rec) => ({
        ...rec,
        isActive: false,
      })
    );
    dispatch(ProjectNotificationActions.setProjectNotifications(response));
  };
};
